// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ProductCatalogPage = lazy(() => import('./pages/ProductCatalogPage'));
const DynamicPricingPage = lazy(() => import('./pages/DynamicPricingPage'));
const QuoteBuilderPage = lazy(() => import('./pages/QuoteBuilderPage'));
const QuoteCollaborationPage = lazy(() => import('./pages/QuoteCollaborationPage'));
const QuoteToOrderPage = lazy(() => import('./pages/QuoteToOrderPage'));
const QuoteApprovalsPage = lazy(() => import('./pages/QuoteApprovalsPage'));
const SubscriptionPricingPage = lazy(() => import('./pages/SubscriptionPricingPage'));

export const CpqRoutes: RouteObject = {
  path: 'cpq',
  element: <ModuleGuard moduleId="sales.cpq" />,
  children: [
    { path: 'product-catalog', element: <ProductCatalogPage />, handle: { crumb: 'Product Catalog' } },
    { path: 'dynamic-pricing', element: <DynamicPricingPage />, handle: { crumb: 'Dynamic Pricing' } },
    { path: 'quote-builder', element: <QuoteBuilderPage />, handle: { crumb: 'Quote Builder' } },
    { path: 'quote-collaboration', element: <QuoteCollaborationPage />, handle: { crumb: 'Quote Collaboration' } },
    { path: 'quote-to-order', element: <QuoteToOrderPage />, handle: { crumb: 'Quote To Order' } },
    { path: 'quote-approvals', element: <QuoteApprovalsPage />, handle: { crumb: 'Quote Approvals' } },
    { path: 'subscription-pricing', element: <SubscriptionPricingPage />, handle: { crumb: 'Subscription Pricing' } },
  ],
};
